export default __webpack_public_path__ + "i18n/translations/translation-cs.d806476c.json";